import React, { Fragment } from 'react'

import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import GroupsLoader from './_load/GroupsLoader'
import GroupsTable from './table/GroupsTable'

const PageContent = () => {
  return (
    <>
      <MultiSelectHandler>
        <GroupsLoader uncontrolledChildren={<MultiRowsActions />}>
          <GroupsTable />
        </GroupsLoader>
      </MultiSelectHandler>
    </>
  )
}

export default PageContent
